

export class ScheduleEvent{
    EventId : string="";
    UserId : string="";
    Title : string="";
    FirstName : string="";
    LastName : string="";        
    Email : string="";
    EventType : string="";
    EventColor : string="";
    EventStart: Date;
    EventStartUTC: Date;
    EventEnd: Date;
    EventEndUTC: Date;
    GameId : string="";
    Visibility: string;
    Comment : string="";
    IsMyEvent : boolean = false;
    Venue : string="";
    HomeTeamName : string="";
    HomeTeamIconFileName : string="";
    AwayTeamName : string="";
    AwayTeamIconFileName : string="";
    DivisionName : string="";
    OrganizationId: number=-1;
    Duration: number;
}

export class ScheduleViewModel{
    ActiveMonth: number = 0; 
    ActiveMonthText: number=0; 
    ActiveYear: number=0; 
    StartDateForMonth: number=0; 
    StartDateForMonthView: number=0; 
    StartDateForWeek: number = 0;
    EndDateForMonthView: number=0; 
    EndDateForMonth: number=0; 
    
    EventList: ScheduleEvent[];
    //Days?: CalendarDayModel[];
}

